<template>
	<el-form :model="customerProduct" :rules="rules" ref="editCustomerProductLogForm" label-width="120px" size="medium"  :status-icon="true" label-suffix=" : ">
		<el-form-item label="产品">
			<label>{{customerProduct.productName}}</label>
		</el-form-item>
		<el-form-item label="分类">
			<label>{{customerProduct.productCategoryName}}</label>
		</el-form-item>
		<el-form-item label="交易类型">
			{{typeFormatter(customerProduct.type)}}
		</el-form-item>
		<el-form-item label="份额" prop="portion">
			<el-input-number v-model="customerProduct.portion" :precision="2"  :step="100" :min="0" style="width: 550px;"></el-input-number>
		</el-form-item>
		<el-form-item label="金额(单位:元)" prop="amount" >
			<el-input-number v-model="customerProduct.amount" :precision="2"  :step="1" :min="0" style="width: 550px;"></el-input-number>
		</el-form-item>
		<el-form-item label="交易日期" prop="buyTime" >
			<el-date-picker
				align="right"
				type="date"
				placeholder="赎回日期"
				v-model="customerProduct.buyTime"
				value-format="yyyy-MM-dd"  style="width: 550px;"
			></el-date-picker>
		</el-form-item>
		<el-form-item label="备注" prop="remark" >
			<el-input type="textarea"  :autosize="{ minRows: 2}" :max="200" v-model="customerProduct.remark"  style="width: 550px;" placeholder="请输入详细描述"></el-input>
		</el-form-item>
		<div style="text-align: right;">
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-form>
</template>

<script>
	import axios from "axios"
	import config from "../../../config/global.js";
    export default {
        name: "edit-customer-product-log-panel.vue",
			data:function () {
				return {
					rules: {
						portion: [
							{ required: true, message: '请输入份额', trigger: 'blur' },
							{ type: 'number',min:1, message: '请输入份额', trigger: 'blur' }
						],
						amount: [
							{ required: true, message: '请输入金额', trigger: 'blur' },
							{type: 'number',min:0.01, message: '请输入金额', trigger: 'blur' }
						],
						// buyTime:[
						// 	{ required: true, message: '请输入交易日期', trigger: 'blur' }
						// ],
						remark: [
							{ max: 200, message: '请输入200以下个字符', trigger: 'blur' }
						],
					},
					operating:false,
				}
			},
			props:{
				customer:{},
				customerProduct:{}
			},
			methods:{
        	submit:function () {
						this.$refs.editCustomerProductLogForm.validate((valid) => {
							if (valid) {
								this.customerProduct.customerId = this.customer.id;
								this.operating = true;
								axios({
									method: 'post',
									url:config.host+'/backend/customer/modifybuy.json',
									data:this.customerProduct
								}).then((response)=>{
									var defaultResult = this.responseDefaultHandle(response);
									if(defaultResult == false )
										return;
									if(response.data.result == 1){
										this.$message({
											message: '修改成功',
											type: 'success'
										});
										this.$emit('editcustomerproductsuccess');
									}else{
										this.$alert(response.data.emsg, '修改失败', {
											confirmButtonText: '确定'
										});
									}
									this.operating = false;
									console.log(response.data)
								}).catch((error)=>{
									this.operating = false;
									this.$alert(error.response.statusText, '修改失败', {
										confirmButtonText: '确定'
									});
								})
							} else {
								return false;
							}
						});
					},
				typeFormatter:function (type) {
					if(type == 1){
						return "购买交易";
					}else if(type == 2 ){
						return "赎回交易";
					}else{
						return "";
					}
				}
			}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/customer/EditCustomerProductLogPanel.vue